// @flow
import * as React from 'react';
import OverlayDialog from 'common/components/core/dialog/OverlayDialog';
import { themr } from 'react-css-themr';

import { DivLoader } from 'common/components/core/wrappers/Div';

import { Button, ButtonTypes } from 'common/components/core/button';
import { Loader } from 'common/components/core/loader/Loader';

import defaultTheme from './SingleEntityEditView.scss';
import { dashboardColors } from 'common/enums/ColorEnum';

type Props = {
    theme: Object,
    dataFetchError: ?string,
    onDismiss: () => void,
    fetchResources: () => void,
    children: React.Node,
    t: Object
};

class SingleEntityLoadingView extends React.Component<Props> {
    renderTitle() {
        const { theme } = this.props;
        return (
            <div className={theme.titleSection}>
                <DivLoader loading theme={theme} />
            </div>
        );
    }

    renderFailedState() {
        const { t, theme, dataFetchError, fetchResources } = this.props;
        return (
            <div className={theme.failWrap}>
                <span className={theme.errorMessage}>{dataFetchError}</span>
                <Button
                    buttonType={ButtonTypes.Text}
                    color={dashboardColors.salmonTwo.name}
                    label={t('tryAgain')}
                    theme={theme}
                    className={theme.tryAgain}
                    ripple={false}
                    onClick={fetchResources}
                />
            </div>
        );
    }

    render() {
        const { theme, dataFetchError, onDismiss } = this.props;
        return (
            <OverlayDialog
                active
                className={theme.overlay}
                dialogClassName={theme.dialog}
            >
                <div className={theme.outerContainer}>
                    <Button
                        buttonType={ButtonTypes.Icon}
                        circle
                        icon="cancel"
                        className={theme.closeBtn}
                        theme={theme}
                        onClick={onDismiss}
                    />
                    <div className={theme.container}>
                        {this.renderTitle()}
                        <div className={theme.loading}>
                            {!dataFetchError ? (
                                <Loader active theme={theme} />
                            ) : null}
                            {dataFetchError ? this.renderFailedState() : null}
                        </div>
                    </div>
                </div>
            </OverlayDialog>
        );
    }
}

export default themr(null, defaultTheme)(SingleEntityLoadingView);
